import logo from "../../assets/images/logo.svg";
import logo_white from "../../assets/images/logo_white.svg";

import { useEffect, useState } from "react";
import LoginForm from '../form_elements/LoginForm';
import Dropdownlist from "../customComponents/Dropdownlist";
import styles from "../../assets/stylesheets/sass/Login.module.scss";
import { ReactSession }  from 'react-client-session';
// import Qastan from "@qastanfit/logger"
export default function Login({language}){

	useEffect(()=>{
		setlang_updater(language);
		ReactSession.set("language", language);
	}, [language])

	const [content_state, setcontent_state] = useState({});
	useEffect(()=>{
		const fetchData = async () =>{
			try {
				const data = await fetch(process.env.REACT_APP_SERVER_LINK+"content");
				let res = await data.json();
				setcontent_state(res);
			} catch (error) {}
           
		}
        fetchData();	
	}, [])

	const [lang_updater, setlang_updater] = useState("");
	const handleChangeLanguage = (lang) =>{
		setlang_updater(lang);
		ReactSession.set("language", lang);

		// Qastan.addLog({
		// 	"level":Qastan.level.Info,
		// 	"type":Qastan.type.User_action,
		// 	"details": {
		// 		"title": "Login",
		// 		"description": "User changed language to " + lang,
		// 		"eventtype": "onchange",
		// 	}
		// })
	}

	return (
	    <>	
		<div className={styles.main_container} datatype={lang_updater}>
			<div>
				<div className={styles.logo_container}>
					<img className={styles.logo} src={logo} alt="logo"/>
					<img className={styles.logo_white} src={logo_white} alt="logo"/>
				</div>
				<div className={styles.login_form_main}>
					<div className={styles.login_form}>
						<LoginForm title={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Login.title ? content_state[ReactSession.get("language")].Login.title : "Login here!") : ""}/>
					</div>
				</div>
				
				<div className={styles.language_ddl}>
					<Dropdownlist value={lang_updater} 
                    data={[
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_dutch && content_state[ReactSession.get("language")].General.language_dutch) : "Dutch"), 
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_french && content_state[ReactSession.get("language")].General.language_french) : "French"), 
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_english && content_state[ReactSession.get("language")].General.language_english) : "English")
                    ]}  menuPlacement="auto" isSearchable={false} defaultValue type="language" width="small" onChange={(v)=>handleChangeLanguage(v)}/>
				</div>
			</div>
			<div style={{position:"relative"}} className={styles.right_container}>
				<div style={{marginTop:"-4rem", marginLeft:"4rem"}}>
					<p style={{fontSize:"3.7rem"}}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Login.right_maintitle && content_state[ReactSession.get("language")].Login.right_maintitle) : "Welcome to our Portal"}</p>
					<p style={{fontSize:"1rem", marginTop:"1rem"}}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Login.right_subtitle && content_state[ReactSession.get("language")].Login.right_subtitle) : "Log in om toegang te krijgen tot uw account"}</p>
				</div>
			</div>
		</div>
	    </>  
  	);
}
 